'use client';

import React from 'react';
import { X } from 'lucide-react';
import { useFilters } from '@/context/FiltersContext';

export const ClearFiltersButton: React.FC = () => {
  const { resetFilters, activeFilterCount } = useFilters();
  if (activeFilterCount === 0) return null;

  return (
    <button
      type="button"
      onClick={resetFilters}
      aria-label="Clear all filters"
      className="inline-flex items-center gap-[3px] text-[10px] font-medium text-text-muted hover:text-text-secondary tracking-[0.04em] transition-colors cursor-pointer"
    >
      <X size={11} aria-hidden="true" /> Clear ({activeFilterCount})
    </button>
  );
};
